import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ImmutablePropTypes from 'react-immutable-proptypes';

import FeaturedContent from '@src/components/common/Content/FeaturedContent';
import { TileContainerLarge } from '@src/components/TileContainerLarge';
import { Loader } from '@src/components/ui';
import { Pagination } from '@src/components/ui/Pagination';
import {
    isProductUpdatesLoading,
    getProductUpdates,
    getProductUpdatesPage,
    getProductUpdatesTotal,
    getFeaturedProductUpdates,
    isFeaturedProductUpdatesLoading,
} from '@src/selectors';
import { imageOrDefault } from '@src/utils/defaultImage';

const ProductNewsAndUpdates = ({
    productUpdatesData,
    featuredProductUpdatesData,
}) => {
    const renderFeaturedProductUpdates = () => {
        const articles = getFeaturedProductUpdates(featuredProductUpdatesData).toJS();
        if (articles.length === 0) {
            return null;
        }

        return (
            <FeaturedContent
                articles={articles}
                urlPrefix="/products/product-news-and-updates"
            />
        );
    };

    const renderProductUpdates = () => {
        const articles = getProductUpdates(productUpdatesData).toJS();
        if (articles.length === 0) {
            return (
                <Row>
                    <Col>
                        <p className="text-center">No Results</p>
                    </Col>
                </Row>
            );
        }

        return (
            <Row style={{ flexWrap: 'wrap' }}>
                {
                    articles.map((article, i) => (
                        <TileContainerLarge
                            key={`product-article-${article.id}`}
                            index={i}
                            {...article}
                            image={imageOrDefault(article.image)}
                        />
                    ))
                }
            </Row>
        );
    };

    const renderPagination = () => {
        const page = getProductUpdatesPage(productUpdatesData);
        const total = getProductUpdatesTotal(productUpdatesData);

        return (
            <Row className="mb-3 mt-3">
                <Col className="text-center">
                    <Pagination
                        currentPage={page}
                        total={total}
                    />
                </Col>
            </Row>
        );
    };

    if (
        isProductUpdatesLoading(productUpdatesData)
        || isFeaturedProductUpdatesLoading(featuredProductUpdatesData)
    ) {
        return <Row><Col><Loader /></Col></Row>;
    }

    return (
        <>
            {renderFeaturedProductUpdates()}
            {renderProductUpdates()}
            {renderPagination()}
        </>
    );
};

ProductNewsAndUpdates.propTypes = {
    productUpdatesData: ImmutablePropTypes.mapContains({
        loaded: PropTypes.string.isRequired,
        product_updates: ImmutablePropTypes.listOf(ImmutablePropTypes.mapContains({
            id: PropTypes.number,
        })),
        total: PropTypes.number,
        page: PropTypes.number,
    }).isRequired,
    featuredProductUpdatesData: ImmutablePropTypes.mapContains({
        loaded: PropTypes.string.isRequired,
        productUpdates: ImmutablePropTypes.listOf(ImmutablePropTypes.mapContains({
            id: PropTypes.number,
        })),
    }).isRequired,
};

export default React.memo(ProductNewsAndUpdates);
